export default __webpack_public_path__ + "static/media/17.bc94ef44.jpg";